import React, { useState } from "react";
import { Navigate } from "react-router-dom";

import collectibles from "assets/images/collectiblesimage4.png";
import { PROFILE } from "src/constants/routes";
import SEO from "components/SEO";

/*
  reverse - text left, image right

*/
const GBet = () => {
  const [redirect, setRedirect] = useState(false);

  if (redirect) {
    return <Navigate to={PROFILE.INDEX} />;
  }
  const pageMetaData = {
    pageTitle: `About $GBET | GangstaBet: A Digital Collectible  `,
    pageDescription: null,
    pageKeywords: null,
    pageImage: null,
  };
  return (
    <SEO pageMetaData={pageMetaData}>
      <div className="trading-collectible mx-3 position-relative">
        <div className="container">
          <div className="row">
            <div className="col-md-6 trading-collectible-col text-center">
              <img src={collectibles} alt="background" className="trading" />
            </div>
            <div className="col-md-4 trading-collectible-col">
              <div>
                {/* <p className="pre-title">What is gangstabet</p> */}
                <p className="about-title">GangstaBet Token ($GBET): </p>
                <p className="about-subtitle">
                  GangstaBet takes a unique approach to distribute GangstaBet
                  Token ($GBET) to its holders on a daily basis. The starting
                  amount of $GBET released per day per GangstaBet is 12. $GBET
                  can be used to change the name and upgrade the skills of
                  GangstaBets. Every GangstaBet will start with enough $GBET to
                  change it's name and upgrade some of it's skills.
                  <br />
                  <br />
                  The supply of $GBET will decrease periodically. After 3 and 6
                  years of the release of GangstaBet, the supply will half
                  before stopping completely after 9 years in 2030. As the
                  supply of $GBET decreases over time, changing the name and
                  upgrading skills will become a scarce commodity. This
                  intrinsic rarity is crucial as GangstaBets with sought after
                  names and higher ranks will start becoming more valuable. This
                  will influence how the characters will evolve by 2030.
                  <br />
                  <br />
                  No $GBET will ever be minted except the ones given to the
                  participants during the initial sales and the daily
                  distribution. Hence, GangstaBet won’t have a marketplace to
                  buy additional $GBET token. You will have to wait to receive
                  $GBET daily or wait for $GBET to be listed in ICON DEX. This
                  ensures that the value of $GBET is determined by the market
                  and not controlled by the creators.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SEO>
  );
};

export default GBet;
